<span class="linked-record-status" [title]="accessibleTitle">
  <a
    *ngIf="link; else unlinkedRecord"
    class="linked-record-link text-truncate"
    [routerLink]="link"
    (click)="linkActivated.emit()"
  >{{ label || 'Open record' }}</a>
  <ng-template #unlinkedRecord>
    <span class="linked-record-empty text-truncate">{{ label || 'Not created' }}</span>
  </ng-template>
  <span class="badge badge-sm flex-shrink-0" [ngClass]="badgeClass">
    {{ displayStatus }}
  </span>
</span>
